



























import { Component, Vue, Watch } from 'vue-property-decorator';
import Icon from './generic/Icon.vue';
import { getModule } from 'vuex-module-decorators';
import MainModule from '../store/modules/MainModule';
import { DisplayableError } from '../helpers/DisplayableError';

const mainState = getModule(MainModule);

@Component({
  components: {
    Icon,
  },
})
export default class Toaster extends Vue {
  type = 'error';
  message: DisplayableError | null = null;
  messages: Array<DisplayableError> = [];

  clearMessage(message: DisplayableError) {
    this.message = null;
    mainState.clearError(message);
  }

  get errors(): Array<DisplayableError> {
    return mainState.errors;
  }

  @Watch('errors')
  onErrorsChange(errors: Array<DisplayableError>) {
    if (errors.length) {
      const message = errors[0];
      this.message = message;
      setTimeout(() => {
        this.clearMessage(message);
      }, 10000);
    }
  }
}
